module.exports = __webpack_public_path__ + "static/media/app-img.b7a9c843.jpg";